import {SET_GROUP_MEMBER_TO_ADD} from "@/modules/app/store/mutation-types";

export default {
    [SET_GROUP_MEMBER_TO_ADD](state, payload) {
        state.groupMemberManipulate = payload
    },
}